"use client";

import { AntdRegistry } from "@ant-design/nextjs-registry";

export default function AntdStyleRegistry({ children }: { children: React.ReactNode }) {
  return <AntdRegistry>{children}</AntdRegistry>;
}